import type { ItemAttributes, ItemNames } from '@ps-smart-cp/ppfw-client';
import { Characters, ItemName, Locale } from '@ps-smart-cp/ppfw-client';

interface Schema {
  /**
   * 会社領域Id
   */
  readonly companyRegionId: number;
  /**
   * 会社Id
   */
  readonly companyId: number;
  /**
   * 会社コード
   */
  readonly companyCode: string;
  /**
   * 会社名称
   */
  readonly companyName: string;
}

interface Record {
  readonly companyRegionId: number;
  readonly companyId: number;
  readonly companyCode: string;
  readonly companyName: string;
}

const attributes = {
  companyCode: Characters.preset.alphanumericals(),
  companyName: Characters.preset.freeFormat(),
} satisfies ItemAttributes<Schema>;

const names = {
  companyCode: ItemName.of([Locale.ja, '会社コード'], [Locale.en, 'Company Code']),
  companyName: ItemName.of([Locale.ja, '会社名'], [Locale.en, 'Company Name']),
} satisfies ItemNames<Schema>;

const company = {
  names,
  attributes,
};

interface Company {
  schema: Schema;
  record: Record;
}

export type { Company };
export { company };
